import api from '../../api';
// 获取招聘列表
export function getJobList(params) {
  return api.post('/join/getJobList.go', params, false, false).then(res => res);
}
// 新增招聘
export function addJob(params) {
  return api.post('/join/addJob.go', params, false, false).then(res => res);
}
// 获取招聘详情
export function getJob(params) {
  return api.post('/join/getJob.go', params, false, false).then(res => res);
}
// 更新招聘信息
export function upJob(params) {
  return api.post('/join/upJob.go', params, false, false).then(res => res);
}
// 删除招聘信息
export function delJob(params) {
  return api.post('/join/delJob.go', params, false, false).then(res => res);
}
// 删除招聘信息
export function hideJob(params) {
  return api.post('/join/hideJob.go', params, false, false).then(res => res);
}



// WEBPACK FOOTER //
// ./src/api/adminApi/zh/recruit.js